import omit from 'lodash/omit';
import get from 'lodash/get';

const reduxFormAdapter = (props) => {
  const input = get(props, 'input', {});
  const error = get(props, 'meta.error');
  const focused = get(props, 'meta.active');
  const touched = get(props, 'meta.touched');
  const forceErrorDisplay = get(props, 'forceErrorDisplay');

  return {
    ...omit(props, ['meta', 'input']),
    ...input,
    focused,
    forceErrorDisplay,
    hint: props.hint || props.description,
    error: touched ? error : null,
  };
};

export default reduxFormAdapter;



// WEBPACK FOOTER //
// ./src/lib/redux-form-adapter.js